import { useFunctionalInterfacesStore } from "@/frontend/store/FunctionalInterfaceStore";
import { AddFunctionalInterfaceButton } from "../functionalInterfaces/AddFunctionalInterfaceButton";
import { I18n } from "@/i18n/I18n";

export function FunctionalInterfacesTable() {
  const versionsInProcedure = useFunctionalInterfacesStore((state) => state.functionalInterfaceVersions);
  const functionalInterfaces = useFunctionalInterfacesStore((state) => state.functionalInterfaces);

  return (
    <div className='card'>
      <div className='card-header d-flex justify-content-between align-items-center'>
        <div>{I18n.get('functionalInterfaces')}</div>
        <AddFunctionalInterfaceButton />
      </div>
      <div className='card-body'>
        <table className='table table-hover'>
          <thead>
            <tr>
              <th>{I18n.get('name')}</th>
              <th>{I18n.get('version')}</th>
            </tr>
          </thead>
          <tbody>
            {versionsInProcedure.map((version) => (
              <tr key={version.id}>
                <td>{functionalInterfaces.find((functionalInterface) => functionalInterface.id === version.functionalInterfaceId)?.name}</td>
                <td>{version.versionString}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
